<template>
  <b-card class="card-custom" v-on:click="$emit('card-clicked')">
    <div class="d-flex">
      <span class="svg-icon svg-icon-4x svg-icon-primary">
        <inline-svg src="/media/svg/icons/Communication/Shield-user.svg" />
      </span>

      <div class="d-flex flex-column">
        <h1 class="ml-5 font-weight-bolder text-dark">
          {{ emp }}
        </h1>
        <span class="ml-5 text-muted">
          {{ "Total Employee" }}
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EmployeeCountCard",
  mounted() {
    this.$store.dispatch("fetchEmployeeDashboardCount");
  },
  computed: {
    ...mapGetters({
      emp: "getEmployeeDashboardCount",
    }),
  },
};
</script>

<style scoped></style>
